"use client";

import React, { useContext, useState } from "react";
import styles from "./jump-menu.module.scss";
import { KEY_APPS } from "@/constants/key-apps.constants";
import { usePathname } from "next/navigation";
import Link from "next/link";
import { BsArrowRight } from "react-icons/bs";
import { JumpMenuContext } from "@/providers/jump-menu.provider";
import classNames from "classnames";
import { HiOutlineDocument, HiOutlineDocumentText } from "react-icons/hi";
import { Tooltip } from "antd";
import { HiOutlineDocumentMagnifyingGlass } from "react-icons/hi2";
import MenuTab from "@/components/layout/jump-menu/menu-tab";

type Props = {};

// Contents will contain all of the key app pages and more
const JumpMenu = (props: Props) => {
  const [menuActivated, setMenuActivated] = useState(false);

  const { anchorIdStates } = useContext(JumpMenuContext);

  const pathname = usePathname();
  const activeKeyApp = KEY_APPS.find((app) => app.url === pathname);

  function handleGoTo(position: number) {
    window.scrollTo({
      behavior: "smooth",
      top: position,
    });
  }

  //! If the page passes a breakpoint
  //! Make jump menu dissapear
  //! JM Btn appears
  //! When clicked adds a class to jump menu
  //! Jump menu will show regardless of breakpoints

  return (
    <div className={styles.jumpMenuWrapper}>
      <div className={styles.section}>
        <div className={classNames(styles.jumpMenuContainer)}>
          <div className={classNames(styles.jumpMenuContents, menuActivated && styles.activated)}>
            <MenuTab onClick={() => setMenuActivated((prev) => !prev)} menuOpen={menuActivated} />
            <div className={classNames(styles.jumpMenu)}>
              <div className={styles.header}>Quick access menu</div>
              <div className={styles.lists}>
                <div className={styles.docsButtons}>
                  <Tooltip title="General docs">
                    <Link href="/docs">
                      <button>
                        <HiOutlineDocument size={25} />
                      </button>
                    </Link>
                  </Tooltip>
                  <Tooltip title="Technical docs">
                    <Link href="/docs">
                      <button>
                        <HiOutlineDocumentMagnifyingGlass size={25} />
                      </button>
                    </Link>
                  </Tooltip>
                  <Tooltip title="Whitepaper">
                    <Link href="/docs">
                      <button>
                        <HiOutlineDocumentText size={25} />
                      </button>
                    </Link>
                  </Tooltip>
                </div>
                {/* Current key app anchors */}
                {activeKeyApp && (
                  <div className={styles.listBlock}>
                    <div className={styles.listTitle}>On this page</div>
                    <ul className={styles.listContents}>
                      {anchorIdStates.map((anchor) => (
                        <li key={anchor.name} onClick={() => handleGoTo(anchor.position)} className={classNames(anchor.inView && styles.active)}>
                          {anchor.name}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                {/* KEY APPS  */}
                <div className={styles.listBlock}>
                  <div className={styles.listTitle}>Other key apps</div>
                  <ul className={classNames(styles.listContents, styles.keyApps)}>
                    {KEY_APPS.map((app) => {
                      if (app.url === pathname) return;
                      return (
                        <li key={app.title}>
                          <Link href={app.url}>{app.title}</Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JumpMenu;
